<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M7.20002 3.60001H16.8c1.0606 0 2.0996.5992 2.5739 1.5478C19.9604 6.67745 21.6 10.8 21.6 10.8v8.4c0 .6627-.5372 1.2-1.2 1.2h-1.2c-.6627 0-1.2-.5373-1.2-1.2v-1.8H6.00002v1.8c0 .6627-.53725 1.2-1.2 1.2h-1.2c-.66274 0-1.2-.5373-1.2-1.2v-7.8334s1.52027-4.37774 2.22611-6.21879c.47429-.9486 1.51334-1.5478 2.57389-1.5478Zm11.99998 6-1.2-3.6s-.2686-1.2-1.4486-1.2H7.80002c-1.18002 0-1.35378.33632-1.77822 1.15785L4.80002 9.60001H19.2ZM6.00002 13.2c0 .6627-.53725 1.2-1.2 1.2-.66274 0-1.2-.5373-1.2-1.2s.53726-1.2 1.2-1.2c.66275 0 1.2.5373 1.2 1.2ZM19.2 14.4c.6628 0 1.2-.5373 1.2-1.2s-.5372-1.2-1.2-1.2c-.6627 0-1.2.5373-1.2 1.2s.5373 1.2 1.2 1.2Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            d="M18 14c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1ZM7 15c.55228 0 1-.4477 1-1s-.44772-1-1-1-1 .4477-1 1 .44772 1 1 1Z"
        />
        <path
            fill-rule="evenodd"
            d="M4.82339 5.36754C5.09562 4.55086 5.8599 4 6.72076 4H17.2792c.8609 0 1.6252.55086 1.8974 1.36754L21 10.8377V20c0 .5523-.4477 1-1 1h-1c-.5523 0-1-.4477-1-1v-2H6v2c0 .5523-.44772 1-1 1H4c-.55228 0-1-.4477-1-1v-9c0-.1075.01733-.2143.05132-.3162l1.77207-5.31626ZM19 16v-4H5v4h14ZM17.2792 6H6.72076l-1.33333 4H18.6126l-1.3334-4Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
